// extracted by mini-css-extract-plugin
export default {"limitedCell":"LinkWithDetails_limitedCell__gO7Qn","root":"LinkWithDetails_root__DkqhG","placeHolderShimmer":"LinkWithDetails_placeHolderShimmer__eCQWv"};